import AppInputField from "components/shared/FormComponents/AppInputField";
import { useField, useFormikContext } from "formik";
import { dateFormat, stringToDate } from "helpers/common";
import { Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";

const QuestionDate = ({ question, fieldName }) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(fieldName);
  const period = field?.value?.other_details?.period || [];
  const startDate = period[0] ? stringToDate(period[0]) : null;
  const endDate = period[1] ? stringToDate(period[1]) : null;
  return (
    <>
        {question?.question_dd_labels?.length > 0 && (
        <Row>
          <Col lg="3" md="4" sm="6" className="my-2">
            <h6
              className="m-0 d-flex align-items-start themeBlue fw-bold"
              style={{ fontSize: " 14px" }}
            >
              <span
                className="icn me-1"
                style={{ color: " rgb(61, 160, 170)" }}
              >
                ■{" "}
              </span>{" "}
              {question?.question_dd_labels[0]}
            </h6>
            <DatePicker
              className="form-control"
              placeholderText="MM/DD/YYYY"
              selected={startDate}
              onChange={(date) => setFieldValue(`${fieldName}.other_details.period.0`, dateFormat(date, "YYYY-MM-DD"))}
              selectsStart
              startDate={startDate}
              endDate={endDate}
            />
          </Col>
          <Col lg="3" md="4" sm="6" className="my-2">
            <h6
              className="m-0 d-flex align-items-start themeBlue fw-bold"
              style={{ fontSize: " 14px" }}
            >
              <span
                className="icn me-1"
                style={{ color: " rgb(61, 160, 170)" }}
              >
                ■{" "}
              </span>{" "}
              {question?.question_dd_labels[1]}
            </h6>
            <DatePicker
              className="form-control"
              placeholderText="MM/DD/YYYY"
              selected={endDate}
              onChange={(date) => setFieldValue(`${fieldName}.other_details.period.1`, dateFormat(date, "YYYY-MM-DD"))}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
            />
          </Col>
        </Row>
        )}
      {meta?.touched && meta?.error?.other_details && (
        <div className="error">
          Please enter date
        </div>
      )}
    </>
  )
}

export default QuestionDate;